const config_api = require("../../../config/config").config_api;
const utils = require("../../../utils");
const axios = require('axios');

function request(method, url, data, callback) {
    axios({
        url: url,
        method: method,
        headers: {
            "Content-type": "application/json",
            "Authorization": 'Bearer ' + utils.getAuthToken()
        },
        data: data
    })
    .then(result => {
        return callback(false, result.data)
    })
    .catch(error => {
        if (error.response) {
            return callback(error.response);
        } else if (error.request) {
            return callback("Đường truyền bị gián đoạn");
        } else {
            return callback(error.message);
        }
    });
}

function listAccessRole(callback) {
    request('GET', config_api.accessRoles, {}, callback);
}

function createAccessRole(data, callback) {
    request('POST', config_api.accessRoles, data, callback);
}

function editAccessRole(id, data, callback) {
    request('PATCH', config_api.accessRoles + "/" + id, data, callback);
}

function deleteAccessRole(id, callback) {
    request('DELETE', config_api.accessRoles + "/" + id, {}, callback);
}

function getMe(callback) {
    request('GET', config_api.adminMe, {}, callback);
}

module.exports = {
    listAccessRole : listAccessRole,
    createAccessRole : createAccessRole,
    editAccessRole : editAccessRole,
    deleteAccessRole : deleteAccessRole,
    getMe : getMe
};
